/* RESPONSIBLE TEAM: team-omni */
import type AppService from 'embercom/services/app-service';
import SettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/-private/transition';
import { ReactRoute } from 'embercom/lib/react-route';

class TelegramRoute extends SettingsRoute {
  @service declare permissionsService: $TSFixMe;
  @service declare appService: AppService;
  @service declare intercomEventService: $TSFixMe;
  @service declare intl: IntlService;
  @service declare store: $TSFixMe;
  @service declare router: RouterService;

  reactEnabled() {
    return this.appService.app.canUseFeature('telegram-channel');
  }

  get titleToken() {
    return this.intl.t('new-settings.channels.telegram.title');
  }

  async beforeModel(transition: Transition) {
    super.beforeModel(transition);

    if (!this.appService.app.canUseFeature('telegram-channel')) {
      return this.router.transitionTo('apps.app.settings');
    }

    return this.permissionsService.ensurePermissionWhenTransitioning(
      'can_access_product_settings',
      transition,
    );
  }

  async model() {
    return {
      settings: {},
    };
  }
}

export default ReactRoute(TelegramRoute);
